import { FieldProps } from 'formik'
import * as React from 'react'

import { QuestionWrapper } from '../form.styles'
import { ErrorMessage, InputField, Label, Wrapper } from '../Input/Input.styles'

interface Props extends React.InputHTMLAttributes<any> {
  value?: any
  label: string
  name: string
  text?: string
  hasError?: boolean
  errorMsg?: string
  required?: boolean
  onInputChange?: (event) => void
}

interface State {
  hasFocus: boolean
  value: number
}

class NumberInput extends React.Component<Props & FieldProps<any>, State> {
  constructor(props) {
    super(props)
    if (props.value) {
      this.state = { hasFocus: false, value: props.value }
    } else {
      const formValue = props.form.values[props.field.name]
      const value = formValue ? formValue : 0
      this.state = { hasFocus: false, value }
    }
  }

  onFocus = () => {
    this.setState({ hasFocus: true })
  }

  onBlur = () => {
    this.setState({ hasFocus: false })
  }

  toInt = value => parseInt(value, 10)

  onlyNumbersKeys = (event: React.KeyboardEvent) => {
    if (isNaN(this.toInt(event.key))) {
      event.stopPropagation()
      event.preventDefault()
    }
  }

  onChange = event => {
    let currentValue = event.currentTarget.value

    currentValue = Number(currentValue)
    this.setState({ value: currentValue })
    if (this.props.onInputChange) this.props.onInputChange(event)
    this.props.form.setFieldValue(this.props.field.name, currentValue)
  }

  render() {
    const { label, text, required = false, field, form } = this.props
    const value = this.state.value
    const hasValue = Boolean(value && !isNaN(value) && value > 0)
    const hasError = Boolean(
      (form.touched[field.name] || hasValue) && form.errors[field.name],
    )

    const { hasFocus } = this.state

    return (
      <>
        {text && (
          <QuestionWrapper as="div" size="s" color="black">
            {text}
          </QuestionWrapper>
        )}
        <Wrapper>
          <Label required={required} elevated={hasValue || hasFocus}>
            {label}
          </Label>
          <InputField
            name={field.name}
            value={hasValue ? this.state.value : ''}
            onChange={this.onChange}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            onKeyPress={this.onlyNumbersKeys}
            hasError={hasError}
          />
        </Wrapper>
        {hasError && <ErrorMessage>{form.errors[field.name]}</ErrorMessage>}
      </>
    )
  }
}

export default NumberInput
